import { useState, useEffect } from "react";
import { useAbortedEffect, useHookForm } from "../../../../components/hooks";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import { RecordAPI, MemberAPI } from "../../../../axios/api";
import { AxiosMulti, formatApiResult } from "../../../../axios/request/common";
import axios from "axios";
import moment from "moment";

import {
  FormCalendar,
  FormInputnumber,
  FormRadio,
  FormDropdown,
} from "../../../../components/formElement";
import { formatResData, checkFormUpdate } from "../../../../service/common";
import { checkValValid, rateHandler } from "../common";
import { option_warn_limit, errorRecordMsg } from "../../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModulePopRecordWeightForm({
  prePopOption,
  closePrePop,
  openPrePop,
  setPreReload,
  memberid,
  moduleType,
  memberData,
}) {
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const [profileData, setProfileData] = useState({});
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    date: moment().format("YYYY/MM/DD"),
    type: null,
    height: null,
    weight: null,
    bmi: null,
    memberid: null,
  };
  const {
    handleSubmit,
    getValues,
    setValue,
    reset,
    watch,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  // 監聽欄位
  const watchColumn = {
    height: watch("height"),
    weight: watch("weight"),
  };

  useEffect(() => {
    setSchema(
      yup
        .object({
          memberid: yup
            .number()
            .test("isValidPass", "必填", (value) => {
              return moduleType === "back" && !memberid ? value : true;
            })
            .nullable(),
          date: yup.string().required("必填"),
          type: yup.number().required("必填"),
          weight: yup.number().required("必填"),
        })
        .required()
    );
  }, []);

  // 動態判斷欄位
  useEffect(() => {
    let submitData = getValues(),
      bmi =
        submitData.height && submitData.weight
          ? submitData.weight /
            ((submitData.height * submitData.height) / 10000)
          : 0;
    setValue("bmi", Math.round(bmi * 10) / 10);
  }, [watchColumn.height, watchColumn.weight]);

  useAbortedEffect((signal) => {
    dispatch(setProgress(true));

    let params = {
      profile: { id: redux_user.userDetail.id },
      detail: { id: prePopOption.data?.id },
    };

    let promise = [
      MemberAPI.getUserListDeatils({
        data: params.profile,
        options: { signal },
      }),
    ];

    if (prePopOption.data) {
      promise.push(
        RecordAPI.getRecordWeightDetails({
          data: params.detail,
          options: { signal },
        })
      );
    }

    AxiosMulti(promise).then(
      axios.spread((result_profile, result_detail = { Response: 1 }) => {
        let formatData = {};

        let { data: result_profile_data } = result_profile;
        if (result_profile.Response === 1) {
          formatData = { height: result_profile_data.height };
          setProfileData(result_profile_data);
        }

        let { data: result_detail_data } = result_detail;
        if (result_detail.Response === 1 && result_detail_data) {
          formatData = { ...formatData, ...result_detail_data };
          setApiData(result_detail_data);
        }

        let temp = formatResData(defaultValues, formatData);
        reset(temp);

        let isError = formatApiResult({
          data: [result_profile, result_detail],
          action: (message) => {
            dispatch(
              setToast({
                severity: "error",
                summary: message,
                detail: "",
              })
            );
          },
        });
        if (isError) {
          dispatch(setProgress(false));
          return;
        }

        dispatch(setProgress(false));
      })
    );
  }, []);

  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let isAdd = !prePopOption.data,
      jsonData = formatResData(defaultValues, submitData);
    if (jsonData.date)
      jsonData.date = moment(jsonData.date).format("YYYY-MM-DD");

    if (!checkFormUpdate(jsonData, prePopOption.data ?? {})) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      closePrePop({ type: "form" });
      return;
    }

    let promise,
      toast = "";
    if (isAdd) {
      // 新增
      promise = RecordAPI.setRecordWeightData({
        data: {
          ...jsonData,
          memberid: submitData.memberid ?? memberid,
        },
      });
      toast = "新增";
    } else {
      // 修改
      if (jsonData.date === prePopOption.data.date) delete jsonData.date;
      promise = RecordAPI.updateRecordWeightData({
        data: {
          ...jsonData,
          id: prePopOption.data.id,
        },
      });
      toast = "修改";
    }

    promise.then(async (result) => {
      let { Response, my_old_day_data, my_todays_data, message } = result;

      if (Response === 1) {
        await rateHandler({
          memberid: submitData.memberid ?? memberid,
          my_old_day_data,
          my_todays_data,
          old_date: isAdd ? null : prePopOption.data.date,
          now_date: submitData.date,
        });

        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
        closePrePop({ type: "form" });
        setPreReload((state) => ({ ...state, list: true }));

        // 檢查資料異常值，跳出警示通知
        if (
          jsonData.bmi &&
          jsonData.bmi !== prePopOption.data?.bmi &&
          checkValValid({
            warn_limit: option_warn_limit,
            field: "bmi",
            val: jsonData.bmi,
          })
        ) {
          openPrePop({ type: "confirm", data: { msg: errorRecordMsg } });
        }
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <div className="px-4">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          {moduleType === "back" && !memberid && (
            <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
              <label
                htmlFor="memberid"
                className={classNames(
                  { "p-error": errors.memberid },
                  "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
                )}
              >
                <span className="text-red-400 mr-1">*</span>
                會員
              </label>
              <div className="col-12 sm:col-9">
                <FormDropdown
                  setting={setting}
                  data={{
                    name: "memberid",
                    options: memberData,
                    optionLabel: "name",
                    optionValue: "id",
                    filter: true,
                    filterBy: "name",
                    disabled: prePopOption.data,
                  }}
                />
              </div>
            </div>
          )}

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="date"
              className={classNames(
                { "p-error": errors.date },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              日期
            </label>
            <div className="col-12 sm:col-9">
              <FormCalendar
                setting={setting}
                data={{
                  name: "date",
                  // disabled: true,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="type"
              className={classNames(
                { "p-error": errors.type },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              時段
            </label>
            <div className="flex flex-wrap col-12 sm:col-9">
              <FormRadio
                setting={setting}
                data={{
                  name: "type",
                  label: "早上",
                  value: 1,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "type",
                  label: "下午",
                  value: 2,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "type",
                  label: "晚上",
                  value: 3,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="weight"
              className={classNames(
                { "p-error": errors.weight },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              體重
            </label>
            <div className="flex col-12 sm:col-9">
              <FormInputnumber
                className="w-full -mr-1px"
                setting={setting}
                data={{
                  name: "weight",
                }}
              />
              <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
                公斤
              </div>
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="height"
              className={classNames(
                { "p-error": errors.height },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              身高
            </label>
            <div className="flex col-12 sm:col-9">
              <FormInputnumber
                className="w-full -mr-1px"
                setting={setting}
                data={{
                  name: "height",
                  disabled: true,
                }}
              />
              <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
                公分
              </div>
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="bmi"
              className={classNames(
                { "p-error": errors.bmi },
                "col-12 sm:col-3 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              BMI
            </label>
            <div className="flex col-12 sm:col-9">
              <FormInputnumber
                className="w-full -mr-1px"
                setting={setting}
                data={{
                  name: "bmi",
                  disabled: true,
                }}
              />
              <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
                kg/m²
              </div>
            </div>
          </div>

          <div className="col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => closePrePop({ type: "form" })}
            />
            <Button type="submit" label="儲存" className="ml-2 mr-2 px-3" />
          </div>
        </form>
      </div>
    </>
  );
}
